// Deterministic Serbian Latin ↔ Cyrillic (display only; canonical code stays "sr"). Mirrors backend/serbian_script.py.
const LAT = "abvgdđežzijklmnoprstćufhcčš";
const CYR = "абвгдђежзијклмнопрстћуфхцчш";
const toCyrMap = {}; const toLatMap = {};
[...LAT].forEach((l, i) => { toCyrMap[l] = CYR[i]; toCyrMap[l.toUpperCase()] = CYR[i].toUpperCase(); toLatMap[CYR[i]] = l; toLatMap[CYR[i].toUpperCase()] = l.toUpperCase(); });
const DIGRAPH_LAT = { "џ": "dž", "љ": "lj", "њ": "nj" };
const LIGATURES = { "Ǆ": "DŽ", "ǅ": "Dž", "ǆ": "dž", "Ǉ": "LJ", "ǈ": "Lj", "ǉ": "lj", "Ǌ": "NJ", "ǋ": "Nj", "ǌ": "nj" };
const DIGRAPHS = [["DŽ", "Џ"], ["Dž", "Џ"], ["dž", "џ"], ["LJ", "Љ"], ["Lj", "Љ"], ["lj", "љ"], ["NJ", "Њ"], ["Nj", "Њ"], ["nj", "њ"]];
const isAlpha = (c) => !!c && c.toLowerCase() !== c.toUpperCase();
const isUpper = (c) => isAlpha(c) && c === c.toUpperCase();

export const srToLatin = (s) => {
  const chars = [...(s || "").normalize("NFC")];
  return chars.map((ch, i) => {
    const low = ch.toLowerCase();
    const lat = DIGRAPH_LAT[low];
    if (!lat) return toLatMap[ch] ?? ch;
    if (ch === low) return lat;
    const nxt = chars[i + 1] || ""; const prv = chars[i - 1] || "";
    const allCaps = isAlpha(nxt) ? isUpper(nxt) : isUpper(prv);
    return allCaps ? lat.toUpperCase() : lat[0].toUpperCase() + lat.slice(1);
  }).join("");
};
export const srToCyrillic = (s) => {
  let out = [...(s || "").normalize("NFC")].map((c) => LIGATURES[c] ?? c).join("");
  DIGRAPHS.forEach(([a, b]) => { out = out.split(a).join(b); });
  return [...out].map((c) => toCyrMap[c] ?? c).join("");
};
export const srDisplay = (text, script) => (script === "latin" ? srToLatin(text) : srToCyrillic(text));
